var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.271,
    height: 22.977,
    viewBox: "0 0 40.271 22.977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.243,0a2.183,2.183,0,0,1,2.209,2.154V16.515a2.183,2.183,0,0,1-2.209,2.154h-.736a4.419,4.419,0,0,1-8.836,0h-5.89a4.365,4.365,0,0,1-4.418,4.308,4.365,4.365,0,0,1-4.418-4.308H1.473a1.437,1.437,0,1,1,0-2.872V10.649a2.837,2.837,0,0,1,.861-2.033L5.89,5.147a2.985,2.985,0,0,1,2.085-.839h2.333V2.154A2.183,2.183,0,0,1,12.517,0ZM10.308,7.18H7.975L4.418,10.649v.839h5.89ZM24.3,18.669a2.21,2.21,0,1,0-2.209,2.154A2.182,2.182,0,0,0,24.3,18.669ZM7.363,16.515a2.155,2.155,0,1,0,2.209,2.154A2.182,2.182,0,0,0,7.363,16.515Z",
    transform: "translate(0 0)",
    fill: "rgba(139,139,139,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.048,19.366H.728A.728.728,0,0,1,0,18.638v-3.4a.728.728,0,0,1,.728-.728h18.32V11.717a1.456,1.456,0,0,1,2.486-1.03l5.222,5.222a1.456,1.456,0,0,1,0,2.059l-5.222,5.222a1.456,1.456,0,0,1-2.486-1.03Z",
    transform: "translate(11.94 -9.222)",
    fill: "#81e9ae",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckOut);
export default __webpack_public_path__ + "static/media/truck-out.47aa9be6373a0cde9bd16970d25f8923.svg";
export { ForwardRef as ReactComponent };